import React, { useState, useEffect } from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Up, Down, Left, Right } from "../components/PositionFade";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useSpring, useSprings, useScroll, animated } from "@react-spring/web";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import {
  LeftInView,
  RightInView,
  UpInView,
  DownInView,
} from "./PositionFadeInView";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DataObjectIcon from "@mui/icons-material/DataObject";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import {
  Box,
  Container,
  Typography,
  Checkbox,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { layout } from "./Layout";

export function YouWillGet(props) {
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "40px",
        backgroundColor: "#111",
        paddingBottom: "100px",
        paddingTop: state.auth.isMobile ? "40px" : "100px",
      }}
    >
      <Grid
        container
        alignItems="center"
        spacing={0}
        justifyContent={"space-between"}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            fontWeight: 600,
            color: "white",
            marginBottom: state.auth.isMobile ? "25px" : "0px",
          }}
        >
          <h2>{props.willget ?? "You will get"}</h2>
        </Grid>
        <Grid item xs={12} md={6} sm={4} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginBottom: state.auth.isMobile ? "25px" : "0px",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "2.2vh",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AppRegistrationIcon
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "50px",
                  color: "white",
                }}
              />
            </div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                marginTop: "10px",
              }}
            >
              {props.title1}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} sm={4} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginBottom: state.auth.isMobile ? "25px" : "0px",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "2.2vh",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AccountTreeIcon
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "50px",
                  color: "white",
                }}
              />
            </div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                marginTop: "10px",
              }}
            >
              {props.title2}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} sm={4} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginBottom: state.auth.isMobile ? "25px" : "0px",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "2.2vh",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <DataObjectIcon
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "50px",
                  color: "white",
                }}
              />
            </div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                marginTop: "10px",
              }}
            >
              {props.title3}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} sm={4} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginBottom: state.auth.isMobile ? "25px" : "0px",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "2.2vh",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AutoGraphIcon
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "50px",
                  color: "white",
                }}
              />
            </div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                marginTop: "10px",
              }}
            >
              {props.title4}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} sm={4} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginBottom: state.auth.isMobile ? "25px" : "0px",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "2.2vh",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EqualizerIcon
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "50px",
                  color: "white",
                }}
              />
            </div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                marginTop: "10px",
              }}
            >
              {props.title5}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export function Advantages(props) {
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        // filter: props.invert ? "invert(1)" : "invert(0)",
        width: state.auth.isTablet ? "97.5vw" : "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding:
          state.auth.isMobile || state.auth.view == "TABP" ? "0px" : "150px",
        backgroundColor: "#111",
      }}
    >
      <div
        className="anigrad"
        style={{
          width: "100%",
          backgroundColor: "#ddd",
          borderRadius:
            state.auth.isMobile || state.auth.view == "TABP" ? "0px" : "50px",
          textAlign: "center",
          fontWeight: 600,
          fontSize: state.auth.isMobile ? "30px" : "5vh",
          color: "white",
          padding: state.auth.isMobile ? "2.2vh" : "100px",
        }}
      >
        <h2>{props.title}</h2>
        <br />
        <br />
        <Grid
          container
          alignItems="center"
          justifyContent={"space-between"}
          spacing={3}
          style={{ width: state.auth.isMobile ? "110%" : "100%" }}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: state.auth.isMobile ? "22px" : "3.2vh",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            <h3>{props.title1}</h3>
            <div
              style={{
                marginTop: "15px",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                fontWeight: "normal",
                lineHeight: "2.5vh",
              }}
            >
              {props.subtitle1}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: state.auth.isMobile ? "22px" : "3.2vh",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            <h3>{props.title2}</h3>
            <div
              style={{
                marginTop: "15px",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                fontWeight: "normal",
                lineHeight: "2.5vh",
              }}
            >
              {props.subtitle2}
            </div>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          alignItems="center"
          justifyContent={"space-between"}
          spacing={3}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: state.auth.isMobile ? "22px" : "3.2vh",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            <h3>{props.title3}</h3>
            <div
              style={{
                marginTop: "15px",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                fontWeight: "normal",
                lineHeight: "2.5vh",
              }}
            >
              {props.subtitle3}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: state.auth.isMobile ? "22px" : "3.2vh",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            <h3>{props.title4}</h3>
            <div
              style={{
                marginTop: "15px",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                color: "white",
                fontWeight: "normal",
                lineHeight: "2.5vh",
              }}
            >
              {props.subtitle4}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export function OurProcess(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding:
          state.auth.isMobile || state.auth.view == "TABP" ? "10px" : "15vh",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            fontWeight: 600,
            color: "white",
            textAlign: "left",
            marginLeft: state.auth.isMobile ? "2.2vh" : "0px",
            marginBottom: state.auth.isMobile ? "-50px" : "0px",
          }}
        >
          {props.process ?? "Our Process"}
          <div
            style={{
              fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              color: "#bbb",
              fontWeight: "lighter",
            }}
          >
            We work in smaller phases, gather feedback at each, and iterate on
            our ideas. This is our proven method for creating world-class
            products, that convert and win hearts.
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "2.8vh",
                textAlign: "left",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              <div style={{ marginTop: "-15px" }}>
                <h3>{props.step1}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              }}
            >
              {props.step1description}
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                textAlign: "left",
                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "2.8vh",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              <div style={{ marginTop: "-15px" }}>
                <h3>{props.step2}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              }}
            >
              {props.step2description}
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                textAlign: "left",
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "2.8vh",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              <div style={{ marginTop: "-15px" }}>
                <h3>{props.step3}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: props.step3description }}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                textAlign: "left",
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "2.8vh",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              <div style={{ marginTop: "-15px" }}>
                <h3>{props.step4}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              }}
            >
              {props.step4description}
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function FAQ(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding:
          state.auth.isMobile || state.auth.view == "TABP" ? "10px" : "15vh",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            fontWeight: 600,
            color: "white",
            textAlign: state.auth.isMobile ? "center" : "left",
            marginBottom: state.auth.isMobile ? "-50px" : "0px",
          }}
        >
          <h2>All the A's to your Q's</h2>
          <div
            style={{
              fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              color: "#bbb",
              fontWeight: "lighter",
            }}
          >
            You have questions? We have answers!
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              <div style={{ marginTop: "-15px" }}>
                <h3>1. What is digital marketing?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Digital marketing promotes businesses through online channels such
              as search engines and social media. It includes strategies that
              improve visibility and attract potential customers. Businesses use
              digital marketing to create{" "}
              <Link to="/branding/">
                brand awareness
              </Link>{" "}
              and generate leads.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              <div style={{ marginTop: "-15px" }}>
                <h3>2. Why should I invest in digital marketing?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Our solutions increase brand visibility and attract targeted
              users. We also provide{" "}
              <Link to="/end-to-end-analytics/">
                campaign analytics
              </Link>{" "}
              that help businesses scale. Digital marketing delivers insights
              that help brands refine strategies. This improves efficiency and
              strengthens customer engagement.
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],
                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>
                  3. What are the most common digital marketing strategies?
                </h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Our expertise covers SEO and PPC advertising. We also focus on
              <Link to="/social-media-management/">
                social media marketing
              </Link>{" "}
              to enhance{" "}
              <Link to="/blog/social-media-marketing-hacks-to-double-your-brand-engagement/">
                audience engagement
              </Link>
              . Each strategy is customized to match the brand’s objectives.
              Businesses can use one or a combination of these approaches for
              better reach.
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>
                  4. How do I know if my digital marketing efforts are working?
                </h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Our performance metrics track website traffic and conversion
              rates. We also monitor engagement levels to evaluate campaign
              success. Businesses can analyze user behavior and campaign data.
              This provides clarity on what works best and where improvements
              are needed.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded5}
            onClick={() => {
              setExpanded5(!expanded5);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>5. What is SEO and why is it important?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              SEO improves website visibility on search engines. Our SEO
              strategies increase organic traffic and strengthen brand
              credibility. A well-optimized website ranks higher and attracts
              more visitors. This improves trust and increases the chances of
              conversions.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded6}
            onClick={() => {
              setExpanded6(!expanded6);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",

                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>
                  6. How can I reach my audience through digital marketing?
                </h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Our data-driven approach helps businesses engage users on search
              engines and social media. We also use content platforms to
              maximize audience outreach. Digital marketing enables precise
              targeting based on user interests. This helps brands connect with
              potential customers and improve engagement.
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function FAQ2(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding:
          state.auth.isMobile || state.auth.view == "TABP" ? "10px" : "15vh",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            fontWeight: 600,
            color: "white",
            textAlign: "left",
            textAlign: state.auth.isMobile ? "center" : "left",
            marginBottom: state.auth.isMobile ? "-50px" : "0px",
          }}
        >
          <h2>All the A's to your Q's</h2>
          <div
            style={{
              fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              color: "#bbb",
              fontWeight: "lighter",
            }}
          >
            You have questions? We have answers!
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>1. {props.q1}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: props.a1 }} />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>2.{props.q2}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: props.a2 }} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>3. {props.q3}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: props.a3 }} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>4. {props.q4}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: props.a4 }} />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded5}
            onClick={() => {
              setExpanded5(!expanded5);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>5. {props.q5}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              {props.a5}
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded6}
            onClick={() => {
              setExpanded6(!expanded6);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",

                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>6. {props.q6}</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: props.a1 }} />
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function FAQSoft(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: state.auth.isMobile ? "10px" : "15vh",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            fontWeight: 600,
            color: "white",
            textAlign: "left",
            textAlign: state.auth.isMobile ? "center" : "left",
            marginBottom: state.auth.isMobile ? "-50px" : "0px",
          }}
        >
          <h2>All the A's to your Q's</h2>
          <div
            style={{
              fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
              color: "#bbb",
              fontWeight: "lighter",
            }}
          >
            You have questions? We have answers!
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>What is software development?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Software development is the process of designing, creating,
              testing, and maintaining software applications or systems. It
              involves various stages such as planning, coding, debugging,
              deployment, and ongoing maintenance.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>What languages do you use in development?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Common programming languages include Python, Java, JavaScript,
              C++, C#, Ruby, PHP, and Swift, among others. The choice of
              language depends on the project requirements, platform, and
              functionality.
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>What is the software development lifecycle (SDLC)?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <li>
                <strong>Requirement gathering:</strong> Collecting business and
                technical requirements.
              </li>
              <li>
                <strong>System design:</strong> Designing architecture, user
                interfaces, and databases.
              </li>
              <li>
                <strong>Development:</strong> Writing and coding the software
                application.
              </li>
              <li>
                <strong>Testing:</strong> Identifying and fixing bugs and issues
                to ensure quality.
              </li>
              <li>
                <strong>Deployment:</strong> Deploying the software for users or
                customers.
              </li>
              <li>
                <strong>Maintenance:</strong> Updating and improving the
                software after launch.
              </li>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>What are the different types of software development? </h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <ul>
                <li>
                  <strong>Web Development:</strong> Building applications that
                  run on web browsers.
                </li>
                <li>
                  <strong>Mobile Development:</strong> Creating applications for
                  mobile devices (iOS, Android).
                </li>
                <li>
                  <strong>Desktop Development:</strong> Designing software for
                  computers (Windows, Mac, Linux).
                </li>
                <li>
                  <strong>Game Development:</strong> Developing interactive
                  games.
                </li>
                <li>
                  <strong>Embedded Systems Development:</strong> Programming
                  hardware devices with software.
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded5}
            onClick={() => {
              setExpanded5(!expanded5);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>What is Agile software development?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Agile is a methodology that emphasizes iterative development,
              collaboration, and flexibility. It focuses on delivering small,
              incremental improvements to software in short cycles called
              "sprints" and adjusting the development process based on feedback.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded6}
            onClick={() => {
              setExpanded6(!expanded6);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: layout.accordiaonBox.height[state.auth.view],

                color: "white",
                fontSize: layout.textMedium[state.auth.view],
                alignItems: "center",
                borderBottom: "2px solid white",
                textAlign: "left",
              }}
              expandIcon={
                <ExpandMoreIcon
                  style={{ fontSize: "3.25vh", color: "white" }}
                />
              }
            >
              {" "}
              <div style={{ marginTop: "-15px" }}>
                <h3>How long does it take to develop software?</h3>
              </div>
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              The time required to develop software depends on factors such as
              the complexity of the project, the team size, the technology
              stack, and the scope of the requirements. Simple applications may
              take a few weeks, while larger systems can take several months or
              even years to develop fully.
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function Collage(props) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        padding: "150px",
        backgroundColor: props.invert ? "white" : "#111",
        marginBottom: "125vh",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "10%",
          width: "30vh",
          height: "30vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1719937206255-cc337bccfc7d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "20%",
          marginTop: "10vh",
          width: "50vh",
          height: "50vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "50%",
          marginTop: "-10vh",
          width: "80vh",
          height: "80vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8b2ZmaWNlfGVufDB8fDB8fHww')",
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          left: "10%",
          width: "40vh",
          height: "40vh",
          marginTop: "50vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "35%",
          marginTop: "40vh",
          width: "100vh",
          height: "100vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "15%",
          marginTop: "10vh",
          width: "60vh",
          height: "60vh",
          marginTop: "70vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
    </div>
  );
}

export function Marquee(props) {
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        width: "100vw",
        backgroundColor: props.invert ? "white" : "#111",
      }}
    >
      <marquee>
        <div
          style={{
            display: "flex",
            fontSize: "6vh",
            color: props.invert ? "black" : "white",
            display: "flex",
          }}
        >
          <div style={{ marginLeft: "50px" }}>+ Paid Ads and Monetization</div>
          <div style={{ marginLeft: "50px" }}>+ SEO and Social</div>
          <div style={{ marginLeft: "50px" }}>+ Analytics and data</div>
          <div style={{ marginLeft: "50px" }}>+ Content creation</div>
        </div>
      </marquee>
      <marquee direction={"right"}>
        <div
          style={{
            display: "flex",
            fontSize: "6vh",
            color: props.invert ? "black" : "white",
            display: "flex",
          }}
        >
          <div style={{ marginLeft: "50px" }}>+ Web design</div>
          <div style={{ marginLeft: "50px" }}>
            + Mobile Application Development
          </div>
          <div style={{ marginLeft: "50px" }}>+ E-Commerce</div>
          <div style={{ marginLeft: "50px" }}>+ UI/UX Development</div>
        </div>
      </marquee>
    </div>
  );
}

export function Collage2() {
  return (
    <div className="grid" style={{ height: "100vh" }}>
      <div className="grid-item1"></div>
      <div className="grid-item2"></div>
      <div className="grid-item3"></div>
      <div className="grid-item4"></div>
      <div className="grid-item5"></div>
      <div className="grid-item6"></div>
      <div className="grid-item7"></div>
      <div className="grid-item8"></div>
    </div>
  );
}

export function Trust(props) {
  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t1.png")} />
            </div>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"AdSparc"}
                style={{ width: "75%" }}
                src={require("../img/t2.png")}
              />
            </div>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t3.png")} />
            </div>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t4.jpg")} />
            </div>
          ),
        },
        {
          id: "item-5",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"Transcendingmonkeys"}
                style={{ width: "75%" }}
                src={require("../img/t5.png")}
              />
            </div>
          ),
        },
        {
          id: "item-6",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"Exiber"}
                style={{ width: "75%" }}
                src={require("../img/t6.png")}
              />
            </div>
          ),
        },
        {
          id: "item-7",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"Elemzy"}
                style={{ width: "75%" }}
                src={require("../img/t7.png")}
              />
            </div>
          ),
        },
        {
          id: "item-8",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t8.jpg")} />
            </div>
          ),
        },
        {
          id: "item-10",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"MyMedBook"}
                style={{ width: "75%" }}
                src={require("../img/t9.png")}
              />
            </div>
          ),
        },
        {
          id: "item-9",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"ZeroZilla"}
                style={{ width: "75%" }}
                src={require("../img/t10.jpg")}
              />
            </div>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 2000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  return (
    <div className="logo-carousel-section">
      <div
        className="logo-carousel-heading"
        style={{ color: props.invert ? "white" : "black" }}
      >
        <h2>Globally Trusted Companies</h2>
      </div>
      <div className="logo-carousel-frame">
        {carouselFragment}
      </div>
    </div>
  );
}

export function Platforms(props) {
  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"Aniview"}
                style={{ width: "75%" }}
                src={require("../img/p1.png")}
              />
            </div>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt={"Perpetua"}
                style={{ width: "75%" }}
                src={require("../img/p2.jpg")}
              />
            </div>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p3.jpg")} />
            </div>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "75%" }}
                alt={"Albersons"}
                src={require("../img/p4.png")}
              />
            </div>
          ),
        },
        {
          id: "item-5",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "75%" }}
                alt={"Meta Ads"}
                src={require("../img/p5.png")}
              />
            </div>
          ),
        },
        {
          id: "item-6",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "75%" }}
                alt={"Campaign Manager"}
                src={require("../img/p6.png")}
              />
            </div>
          ),
        },
        {
          id: "item-7",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "75%" }}
                alt={"Twitter"}
                src={require("../img/p7.png")}
              />
            </div>
          ),
        },
        {
          id: "item-8",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p8.png")} />
            </div>
          ),
        },
        {
          id: "item-9",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "2.2vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p9.png")} />
            </div>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 2000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  return (
    <div id="platforms-managed" className="logo-carousel-section platforms-section">
      <h2
        className="logo-carousel-heading"
        style={{ color: props.invert ? "white" : "black" }}
      >
        Platforms We Manage
      </h2>
      <div className="logo-carousel-frame platforms-carousel-frame">
        {carouselFragment}
      </div>
    </div>
  );
}

export function Tailor(props) {
  const state = useSelector((state) => state);

  return (
    <Grid
      container
      spacing={4}
      justifyContent="space-between"
      style={{
        marginTop: "25px",
        marginBottom: "-25px",
        filter: props.invert ? "invert(1)" : "invert(0)",
      }}
    >
      <Grid item xs={12} md={4}>
        <div
          style={{
            width: "100%",
            minHeight: "17.5vh",
            border: "1px solid grey",
            borderRadius: "5px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "2.2vh",
            paddingTop: "0px",
          }}
        >
          <div
            style={{
              fontSize: layout.subheading2[state.auth.view],
              fontWeight: "bold",
            }}
          >
            {props.title1}
          </div>
          <div
            style={{
              fontSize: layout.textMedium[state.auth.view],
              textAlign: "left",
            }}
          >
            {props.subtitle1}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={4}>
        <div
          style={{
            width: "100%",
            minHeight: "17.5vh",
            border: "1px solid grey",
            borderRadius: "5px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "2.2vh",
            paddingTop: "0px",
          }}
        >
          <div
            style={{
              fontSize: layout.subheading2[state.auth.view],
              fontWeight: "bold",
            }}
          >
            {props.title2}
          </div>{" "}
          <div
            style={{
              fontSize: layout.textMedium[state.auth.view],
              textAlign: "left",
            }}
          >
            {props.subtitle2}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={4}>
        <div
          style={{
            width: "100%",
            minHeight: "17.5vh",
            border: "1px solid grey",
            borderRadius: "5px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "2.2vh",
            paddingTop: "0px",
          }}
        >
          <div
            style={{
              fontSize: layout.subheading2[state.auth.view],
              fontWeight: "bold",
            }}
          >
            {props.title3}
          </div>{" "}
          <div
            style={{
              fontSize: layout.textMedium[state.auth.view],
              textAlign: "left",
            }}
          >
            {props.subtitle3}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export const Features = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container sx={{ py: 8 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 600,
          mb: 4,
          fontFamily: "Montserrat",
          marginBottom: "50px",
          color: themeStyle.primaryColor,
        }}
      >
        Features and Advantages
      </Typography>
      <Grid container justifyContent="center">
        <Grid item key={1} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: themeStyle.primaryColor,
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                variant="h5"
                align="center"
                sx={{ fontWeight: 600, mb: 2 }}
              >
                {""}
              </Typography>
              <Typography
                variant="h4"
                align="center"
                sx={{ fontWeight: 600, mb: 4, color: "primary.main" }}
              >
                {""}
              </Typography>
              <Box style={{ marginTop: "60px" }}>
                {props.features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      color: "white",
                      mb: 6,
                    }}
                  >
                    {feature}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key={2} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: "#ddb6b2",
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid grey",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                  fontWeight: 600,
                }}
              >
                {props.plans[0].name}
              </div>

              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItmes: "center",
                  flexDirection: "column",
                }}
              >
                {props.features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      mb: 2,
                      paddingBottom: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {props.plans[0].features[i] ? (
                      <CheckCircleIcon
                        sx={{ color: "success.main", mr: 1, fontSize: "40px" }}
                      />
                    ) : (
                      <CancelIcon
                        sx={{ color: "error.main", mr: 1, fontSize: "40px" }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key={2} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: "#e8cecc",
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid grey",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                  fontWeight: 600,
                }}
              >
                {props.plans[1].name}
              </div>

              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItmes: "center",
                  flexDirection: "column",
                }}
              >
                {props.features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      mb: 2,
                      paddingBottom: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {props.plans[1].features[i] ? (
                      <CheckCircleIcon
                        sx={{ color: "success.main", mr: 1, fontSize: "40px" }}
                      />
                    ) : (
                      <CancelIcon
                        sx={{ color: "error.main", mr: 1, fontSize: "40px" }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key={2} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: "#f3e6e5",
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid grey",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                  fontWeight: 600,
                }}
              >
                {props.plans[2].name}
              </div>

              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItmes: "center",
                  flexDirection: "column",
                }}
              >
                {props.features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      mb: 2,
                      paddingBottom: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {props.plans[2].features[i] ? (
                      <CheckCircleIcon
                        sx={{ color: "success.main", mr: 1, fontSize: "40px" }}
                      />
                    ) : (
                      <CancelIcon
                        sx={{ color: "error.main", mr: 1, fontSize: "40px" }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
